import { useAppSelector } from '@shared/store';
import { selectIsWithoutCompanies } from '@entities/account';

export const useAccountIsWithoutCompanies = () => {
  const isWithoutCompanies = useAppSelector(selectIsWithoutCompanies);

  return isWithoutCompanies;
};
